import axios from "axios";
import { getLocalStorageVariables } from "./lib/helpers";

export const API = {
  getWidgetConfig: async () => {
    const { partnerId, sourceUrl } = getLocalStorageVariables();
    const url = process.env.REACT_APP_API_ENDPOINT as string;
    const res = await axios.post(url, {
      partnerId,
      sourceUrl,
    });
    const widgetconfig = res.data.data;
    return widgetconfig;
  },
};
